<template>
    <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
  import NotificationSample from 'src/components/NotificationSample';
  export default { 
  }
</script>
